var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('p',[_vm._v("© "),_c('strong',[_vm._v(_vm._s(_vm.year)+" Afrihost.")]),_vm._v(" All rights reserved.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }